import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {
	FormControl,
	FormGroup,
	ControlLabel,
} from 'react-bootstrap';

const flag = [
	{
		name: '重要',
		value: 'star',
		icon: 'star',
	},
	{
		name: '置頂',
		value: 'pin',
		icon: 'pin'
	},
	{
		name: '一般',
		value: 'normal',
		icon: 'newspaper'
	},
];

export class TextField extends React.Component {
	getHelpBlock() {
		let { isAtCreate, showErrorMsg, aNewsTitle } = this.props;

		// 不論何模式都應該提示
		isAtCreate = true;

		if (isAtCreate) {
			if (showErrorMsg) {
				return aNewsTitle === '' ? <span style={{ color: 'red' }}> (標題欄位不可空白)</span> : null;
			} else {
				return null;
			}
		} else {
			//return aNewsTitle === '' ? <HelpBlock>標題請勿空白</HelpBlock> : null;
		}
	}
	render() {
		let { fieldValue, fieldName } = this.props;
		return (
			<FormGroup controlId={this.props.fieldName}>
				{this.props.label ? <ControlLabel>{this.props.label}{this.getHelpBlock()}</ControlLabel> : ''}
				<FormControl
					onFocus={this.props.onFocus}
					type='text'
					value={fieldValue}
					onChange={event => this.props.onChangeHandler(fieldName, event)}>
				</FormControl>
				{this.props.label ? '' : this.getHelpBlock()}
			</FormGroup>
		);
	}
}

export class SelectField extends React.Component {
	getValue(fieldName) {
		let { selectedFlag, selectedNewsTypeId } = this.props;
		switch (fieldName) {
			case 'aNewsFlag':
				return selectedFlag;
			case 'aNewsType_id':
				return selectedNewsTypeId;
			default:
				return '';
		}
	}
	getSelector(fieldName) {
		const flagSelector = flag.map((item, index) => {
			return <option key={index} value={item.value} >{item.name}</option>
		})
		const newsTypeSelector = this.props.newsTypeArray.map((item, index) => {
			return <option key={index} value={item.id} >{item.name}</option>
		})
		switch (fieldName) {
			case 'aNewsFlag':
				return flagSelector;
			case 'aNewsType_id':
				return newsTypeSelector;
			default:
				break;
		}
	}
	render() {
		let { fieldName } = this.props;
		let value = this.getValue(fieldName);
		let selector = this.getSelector(fieldName);
		return (
			<FormGroup>
				<FormControl
					componentClass='select'
					value={value}
					onChange={event => this.props.onChangeHandler(fieldName, event)}>
					{selector}
				</FormControl>
				<FormControl.Feedback />
			</FormGroup>
		);
	}
}

export const DatePickerInstance = props => {
	return (
		<FormGroup>
			<ControlLabel>{props.type === 'aNewsStart_time' ? '開始' : '結束'}</ControlLabel>
			<FormControl componentClass='div' readOnly={!props.enableEdit}>
				<DatePicker
					className='news-date-picker'
					dateFormat='YYYY/MM/DD'
					selected={props.type === 'aNewsStart_time' ? moment(new Date(props.aNewsStart_time)) : moment(new Date(props.aNewsEnd_time))}
					onChange={date => props.onChangeDate(props.type, date)}
				/>
			</FormControl>
		</FormGroup>
	);
}

export class TextAreaField extends React.Component {
	getHelpBlock() {
		let {
			isAtCreate, showErrorMsg, aNewsMessage
		} = this.props;

		// 不論何模式都應該提示
		isAtCreate = true;

		if (isAtCreate) {
			if (showErrorMsg) {
				return aNewsMessage === '' ? <span style={{ color: 'red' }}> (內容欄位不可空白)</span> : null;
			} else {
				return null;
			}
		} else {
			//return aNewsMessage === '' ? <HelpBlock>內容請勿空白</HelpBlock> : null;
		}
	}
	render() {
		let {
			enableEdit, aNewsMessage
		} = this.props;
		return (
			<FormGroup controlId={this.props.fieldName}>
				{this.props.label ? <ControlLabel>{this.props.label}{this.getHelpBlock()}</ControlLabel> : ''}
				<FormControl
					onFocus={this.props.onFocus}
					readOnly={!enableEdit}
					componentClass='textarea'
					value={aNewsMessage}
					onChange={event => this.props.onChangeHandler(this.props.fieldName || 'aNewsMessage', event)}>
				</FormControl>
				<FormControl.Feedback />
				{this.props.label ? '' : this.getHelpBlock()}
			</FormGroup>
		);
	}
}

export const ReadOnlyField = props => {
	return (
		<FormGroup>
			{props.label ? <ControlLabel>{props.label}</ControlLabel> : ''}
			<FormControl
				readOnly={true}
				type='text'
				value={props.fieldValue}>
			</FormControl>
		</FormGroup>
	);
}


// WEBPACK FOOTER //
// ./src/salesky/routes/news/NewsModalComponentsPs.jsx